import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CompanyBenefitVoucher, UserVoucherService, UserVoucher } from 'us-web-services';
import { useDependencies } from '../../../../../dependencies';

export const CareBenefits = (): JSX.Element => {
  const { t } = useTranslation();
  const { stores, services } = useDependencies();
  const { companyBenefits, companies } = stores.companyEmployees;
  const { user } = stores.user;
  const [userVouchers, setUserVouchers] = useState<UserVoucher[]>([]);

  const getVoucherAmount = (vouchers: CompanyBenefitVoucher[] | undefined): number => {
    let amount = 0;
    userVouchers.forEach(voucher => {
      if (vouchers?.find(v => v.voucher?.id === voucher.voucher?.id) && !voucher.voucher?.percentDiscount) {
        amount += voucher?.currentValue ?? 0;
      }
    });
    return amount;
  }

  const getPolicyUrl = (companyId: number | undefined): string | undefined => {
    const company = companies.find(c => c.id === companyId);
    return company?.policyUrl;
  }

  const handlePolicyLinkClick = (companyId: number | undefined): void => {
    services.tracker.track('clicked-care-benefit-policy-link', {
      company_id: companyId,
    });
  }

  const getUserVouchers = async (): Promise<void> => {
    const config = {
      params: {
        userId: user.id,
        active: true,
      }
    };

    const response = (await UserVoucherService.getByFilter(config)).data;
    setUserVouchers(response.data);
  }

  useEffect(() => {
    getUserVouchers();
  }, []);

  if (!companyBenefits.length) {
    return <div />;
  }

  return (
    <div>
      <div className='font-bold'><FontAwesomeIcon icon={faHeart} className='text-bubblegum' />&nbsp;&nbsp;{t('dashboard.widgets.careBenefits.heading')}</div>
      {companyBenefits.map(benefit => {
        const creditAmount = getVoucherAmount(benefit.vouchers);
        const policyUrl = getPolicyUrl(benefit.companyId);
        return (
          <div className='mb-5' key={benefit.id}>
            <div className='bg-neutral-100 text-sm rounded-3xl p-4'>
              <div>{benefit.description}</div>
              <div className='table mt-3'>
                {creditAmount > 0 && (
                  <div className='table-row'>
                    <div className='table-cell'>
                     <span>{t('dashboard.widgets.careBenefits.creditBalance')}</span>
                    </div>
                    <div className='table-cell pl-2 font-bold'>${creditAmount} </div>
                  </div>
                )}

                {creditAmount > 0 && policyUrl && (
                  <div className='mt-2'>
                    <a
                      href={policyUrl}
                      target='_blank'
                      rel='noopener noreferrer'
                      onClick={() => handlePolicyLinkClick(benefit.companyId)}
                    >
                      {t('dashboard.widgets.careBenefits.policyLink')}
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
